[701,301,132,57,23,10,4,1]
